import { Sidebar, Menu, MenuItem } from 'react-pro-sidebar';
import { Link } from 'react-router-dom';
import { IconHome } from './iconHome';
import { IconClients } from './iconClients';
import { IconSair } from './iconSair';
import "./sideMenu.css";
import vnn_logo from '../../assets/vnn_logo.png';

import styles from './Home.module.scss';

export default function SideMenu() {
    return (
        <Sidebar color="#FFFFFF" backgroundColor='#5606A6' height="100vh" width="15%">
            <Menu
                menuItemStyles={{
                    root: {
                    color: "#FFFFFF",
                },
                button: {
                    // the active class will be added automatically by react router
                    // so we can use it to style the active menu item
                    [`&.active`]: {
                    backgroundColor: '#7CFC00',
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(217, 217, 217, 0.08)'
                      },
                },
                }}
            >
                <img className={styles.wrapper} src={vnn_logo} alt="alt text" />
                <MenuItem active={window.location.pathname === "/home"} icon={<IconHome />} component={<Link to="/home" />}>Home</MenuItem>
                <MenuItem active={window.location.pathname === "/clients"} icon={<IconClients />} component={<Link to="/clients" />}>Clients</MenuItem>
                <MenuItem rootStyles="{position: absolute; bottom: 0;}" active={window.location.pathname === "/sair"} icon = {<IconSair />} component={<Link to="/logout" />}>Sair</MenuItem>
                
            </Menu>
            </Sidebar>
    )
}